import React, { useState } from 'react';
import { Input, Row, Col, FormGroup, ButtonGroup, Button} from 'reactstrap';
import checkmark from '../assets/icons/checkmark.png'

const SelectBtnInput = (props) => {
  const {
    label="",
    options,
    isTextField = true,
    updateValue
  } = props

  const [rSelected, setRSelected] = useState(1);

  const selectIndex = (index) => {
    setRSelected(index);
    if(!updateValue || typeof(updateValue) !== 'function') return;
    updateValue(options[index].value)
  }

  return (
  <>
    <p className='body-copy mb-8'>{label}</p>
    <Row className='mb-40'>
      { isTextField && (
        <Col>
        <FormGroup>
          <Input
            placeholder="$0"
          />
        </FormGroup>
      </Col>
      )}
      <Col>
      <ButtonGroup className='w-100 select-btn-group'
        style={{padding:0, border:'none !important'}}
      >
        {options.map((item,index)=>(
          <Button
            outline
            onClick={() => selectIndex(index)}
            active={rSelected === index}
            className={`select-btn-radio ${index===0 ? 'left-btn' : 'rigth-btn'}`}
            key={index}
            style={{padding:8}}
          >
            {(rSelected === index) && <img className="mr-8" src={checkmark}/>}
            {item.label}
          </Button>
        ))}
      </ButtonGroup>
      </Col>
    </Row>
  </>  
  )
}

export default SelectBtnInput;
